import StripeButton from './StripeButton';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import { withModel } from 'src/client/js/view/data-providers/model';

import { getPaymentMethodSession } from 'src/common/facades/eagle/checkout';
import { getCookies } from '../../../../../facades/eagle/helpers/cookies';

const enhance = compose(
  withModel,
  lifecycle({
    componentDidMount() {
      const stripeUrl = 'https://js.stripe.com/v3';
      let stripeScript = document.querySelector(`script[src="${stripeUrl}"]`);

      if (!stripeScript) {
        stripeScript = document.createElement('script');
        stripeScript.src = stripeUrl;
        stripeScript.async = true;
        stripeScript.defer = true;
        const head = document.getElementsByTagName('head')[0];
        head.appendChild(stripeScript);
      }
    },
  }),
  withHandlers({
    handleOnClick: props => () => {
      props.handlePaymentSubmission(async () => {
        const session = await getPaymentMethodSession('stripe', getCookies(), { returnUrl: window.location.href });
        // eslint-disable-next-line new-cap
        const stripe = window.Stripe(session.api_key);
        stripe.redirectToCheckout({
          sessionId: session.session_id
        });
      });
    },
  }),
);

export default enhance(StripeButton);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/StripeButton/index.js